import { themeVariables } from "../constants/tokens.js";
const variants = {
  h1: {
    // heading-4xl
    color: themeVariables.color.text.primary,
    fontFamily: themeVariables.fonts.family.headline,
    fontSize: themeVariables.fonts.size["5xl"],
    fontWeight: themeVariables.fonts.weight.normal,
    lineHeight: themeVariables.fonts.lineHeight["leading-11"],
    letterSpacing: themeVariables.fonts.letterSpacing.tighter
  },
  "heading-3xl": {
    // heading-3xl
    color: themeVariables.color.text.primary,
    fontFamily: themeVariables.fonts.family.headline,
    fontSize: themeVariables.fonts.size["4xl"],
    fontWeight: themeVariables.fonts.weight.normal,
    lineHeight: themeVariables.fonts.lineHeight["leading-10"],
    letterSpacing: themeVariables.fonts.letterSpacing.tight
  },
  h2: {
    // heading-2xl
    color: themeVariables.color.text.primary,
    fontFamily: themeVariables.fonts.family.headline,
    fontSize: themeVariables.fonts.size["4xl"],
    fontWeight: themeVariables.fonts.weight.normal,
    lineHeight: themeVariables.fonts.lineHeight["leading-10"],
    letterSpacing: themeVariables.fonts.letterSpacing.tight
  },
  h3: {
    // heading-xl
    color: themeVariables.color.text.primary,
    fontFamily: themeVariables.fonts.family.headline,
    fontSize: themeVariables.fonts.size["2xl"],
    fontWeight: themeVariables.fonts.weight.normal,
    lineHeight: themeVariables.fonts.lineHeight["leading-7"],
    letterSpacing: themeVariables.fonts.letterSpacing.tight
  },
  h4: {
    // heading-lg
    color: themeVariables.color.text.primary,
    fontFamily: themeVariables.fonts.family.headline,
    fontSize: themeVariables.fonts.size["xl"],
    fontWeight: themeVariables.fonts.weight.normal,
    lineHeight: themeVariables.fonts.lineHeight["leading-6"],
    letterSpacing: themeVariables.fonts.letterSpacing.normal
  },
  h5: {
    // heading-md
    fontFamily: themeVariables.fonts.family.headline,
    fontSize: themeVariables.fonts.size.base,
    fontWeight: themeVariables.fonts.weight.medium,
    lineHeight: themeVariables.fonts.lineHeight["leading-6"],
    letterSpacing: themeVariables.fonts.letterSpacing.normal
  },
  h6: {
    // heading-sm
    fontFamily: themeVariables.fonts.family.body,
    fontSize: themeVariables.fonts.size.sm,
    fontWeight: themeVariables.fonts.weight.medium,
    lineHeight: themeVariables.fonts.lineHeight["leading-5"],
    letterSpacing: themeVariables.fonts.letterSpacing.wide
  },
  body1: {
    // body-base
    fontFamily: themeVariables.fonts.family.body,
    fontSize: themeVariables.fonts.size.base,
    lineHeight: themeVariables.fonts.lineHeight["leading-6"],
    fontWeight: themeVariables.fonts.weight.normal,
    letterSpacing: themeVariables.fonts.letterSpacing.normal
  },
  body2: {
    // remove if not used
    fontFamily: themeVariables.fonts.family.body,
    fontSize: themeVariables.fonts.size.sm,
    lineHeight: themeVariables.fonts.lineHeight["leading-6"],
    fontWeight: themeVariables.fonts.weight.normal,
    letterSpacing: themeVariables.fonts.letterSpacing.normal
  },
  body3: {
    fontFamily: themeVariables.fonts.family.body,
    fontSize: themeVariables.fonts.size.base,
    lineHeight: themeVariables.fonts.lineHeight["leading-5"],
    fontWeight: themeVariables.fonts.weight.normal,
    letterSpacing: themeVariables.fonts.letterSpacing.wide
  },
  "body-sm": {
    fontFamily: themeVariables.fonts.family.body,
    fontSize: themeVariables.fonts.size.sm,
    lineHeight: themeVariables.fonts.lineHeight["leading-5"],
    fontWeight: themeVariables.fonts.weight.normal,
    letterSpacing: themeVariables.fonts.letterSpacing.wide
  },
  "body-xs": {
    fontFamily: themeVariables.fonts.family.body,
    fontSize: themeVariables.fonts.size.xs,
    lineHeight: themeVariables.fonts.lineHeight["leading-4"],
    fontWeight: themeVariables.fonts.weight.normal,
    letterSpacing: themeVariables.fonts.letterSpacing.wider
  },
  subtitle1: {
    fontFamily: themeVariables.fonts.family.body,
    fontSize: themeVariables.fonts.size.sm,
    lineHeight: themeVariables.fonts.lineHeight["leading-7"],
    fontWeight: themeVariables.fonts.weight.normal,
    letterSpacing: themeVariables.fonts.letterSpacing.normal
  },
  subtitle2: {
    fontFamily: themeVariables.fonts.family.body,
    fontSize: themeVariables.fonts.size.base,
    lineHeight: themeVariables.fonts.lineHeight["leading-5"],
    fontWeight: themeVariables.fonts.weight.medium,
    letterSpacing: themeVariables.fonts.letterSpacing.normal
  },
  button: {
    fontFamily: themeVariables.fonts.family.headline,
    fontSize: themeVariables.fonts.size.sm,
    lineHeight: themeVariables.fonts.lineHeight["leading-5"],
    fontWeight: themeVariables.fonts.weight.medium,
    letterSpacing: themeVariables.fonts.letterSpacing.wide
  },
  "card-footer": {
    // borderTop: '1px solid rgba(0, 0, 0, 0.15)',
    fontWeight: themeVariables.fonts.weight.medium,
    fontFamily: themeVariables.fonts.family.headline,
    fontSize: themeVariables.fonts.size.xs,
    fontStyle: "normal",
    lineHeight: themeVariables.fonts.lineHeight["leading-4"],
    letterSpacing: themeVariables.fonts.letterSpacing.wider
  },
  cellHeader: {
    fontFamily: themeVariables.fonts.family.headline,
    fontSize: themeVariables.fonts.size.xs,
    fontStyle: "normal",
    fontWeight: themeVariables.fonts.weight.medium,
    lineHeight: themeVariables.fonts.lineHeight["leading-4"],
    letterSpacing: themeVariables.fonts.letterSpacing.wide
  },
  valueRegular: {
    color: themeVariables.color.text.primary,
    fontWeight: themeVariables.fonts.weight.medium,
    fontFamily: themeVariables.fonts.family.number,
    fontSize: themeVariables.fonts.size["2xl"],
    lineHeight: themeVariables.fonts.lineHeight["leading-7"],
    letterSpacing: themeVariables.fonts.letterSpacing.normal
  },
  valueCell: {
    color: themeVariables.color.text.secondary,
    fontFamily: themeVariables.fonts.family.number,
    fontSize: themeVariables.fonts.size.sm,
    fontStyle: "normal",
    fontWeight: themeVariables.fonts.weight.normal,
    lineHeight: themeVariables.fonts.lineHeight["leading-5"],
    letterSpacing: themeVariables.fonts.letterSpacing.normal
  },
  valueSummary: {
    color: themeVariables.color.text.primary,
    fontFamily: themeVariables.fonts.family.body,
    fontSize: themeVariables.fonts.size.sm,
    fontStyle: "normal",
    fontWeight: themeVariables.fonts.weight.medium,
    lineHeight: themeVariables.fonts.lineHeight["leading-5"],
    letterSpacing: themeVariables.fonts.letterSpacing.wide
  },
  legend: {
    color: themeVariables.color.text.tertiary,
    textAlign: "center",
    fontFamily: themeVariables.fonts.family.body,
    fontSize: themeVariables.fonts.size.base,
    fontStyle: "normal",
    fontWeight: themeVariables.fonts.weight.normal,
    lineHeight: themeVariables.fonts.lineHeight["leading-6"],
    letterSpacing: themeVariables.fonts.letterSpacing.normal
  },
  "number-xl": {
    color: themeVariables.color.text.primary,
    textAlign: "center",
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: themeVariables.fonts.family.number,
    fontSize: themeVariables.fonts.size["3xl"],
    fontStyle: "normal",
    fontWeight: themeVariables.fonts.weight.normal,
    lineHeight: themeVariables.fonts.lineHeight["leading-8"],
    letterSpacing: themeVariables.fonts.letterSpacing.normal
  },
  "number-lg": {
    color: themeVariables.color.text.primary,
    textAlign: "center",
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: themeVariables.fonts.family.number,
    fontSize: themeVariables.fonts.size["2xl"],
    fontStyle: "normal",
    fontWeight: themeVariables.fonts.weight.normal,
    lineHeight: themeVariables.fonts.lineHeight["leading-7"],
    letterSpacing: themeVariables.fonts.letterSpacing.normal
  },
  "number-md": {
    color: themeVariables.color.text.primary,
    fontFamily: themeVariables.fonts.family.number,
    fontSize: themeVariables.fonts.size.base,
    fontStyle: "normal",
    fontWeight: themeVariables.fonts.weight.normal,
    lineHeight: themeVariables.fonts.lineHeight["leading-5"],
    letterSpacing: themeVariables.fonts.letterSpacing.normal,
    ["&.trend-positive"]: {
      color: themeVariables.color.text["trend-up"]
    },
    ["&.trend-neutral"]: {
      color: themeVariables.color.text.primary
    },
    ["&.trend-negative"]: {
      color: themeVariables.color.text["trend-down"]
    }
  },
  "number-sm": {
    color: themeVariables.color.text.secondary,
    fontFamily: themeVariables.fonts.family.number,
    fontSize: themeVariables.fonts.size.sm,
    fontStyle: "normal",
    fontWeight: themeVariables.fonts.weight.normal,
    lineHeight: themeVariables.fonts.lineHeight["leading-5"],
    letterSpacing: themeVariables.fonts.letterSpacing.normal,
    ["&.small"]: {
      fontSize: themeVariables.fonts.size.sm
    },
    ["&.trend-positive"]: {
      color: themeVariables.color.text["trend-up"]
    },
    ["&.trend-neutral"]: {
      color: themeVariables.color.text.primary
    },
    ["&.trend-negative"]: {
      color: themeVariables.color.text["trend-down"]
    }
  },
  "trend-positive": {
    fontFamily: themeVariables.fonts.family.body,
    fontSize: themeVariables.fonts.size.base,
    lineHeight: themeVariables.fonts.lineHeight["leading-6"],
    fontWeight: themeVariables.fonts.weight.normal,
    letterSpacing: themeVariables.fonts.letterSpacing.normal,
    color: themeVariables.color.text["trend-up"]
  },
  "trend-negative": {
    fontFamily: themeVariables.fonts.family.body,
    fontSize: themeVariables.fonts.size.base,
    lineHeight: themeVariables.fonts.lineHeight["leading-6"],
    fontWeight: themeVariables.fonts.weight.normal,
    letterSpacing: themeVariables.fonts.letterSpacing.normal,
    color: themeVariables.color.text["trend-down"]
  },
  "helper-text": {
    fontFamily: themeVariables.fonts.family.body,
    fontSize: themeVariables.fonts.size.xs,
    fontStyle: "normal",
    fontWeight: themeVariables.fonts.weight.normal,
    lineHeight: themeVariables.fonts.lineHeight["leading-4"],
    letterSpacing: themeVariables.fonts.letterSpacing.wide
  },
  link: {
    color: themeVariables.color.text.link,
    fontFamily: themeVariables.fonts.family.body,
    fontSize: themeVariables.fonts.size.base,
    fontStyle: themeVariables.fonts.style.normal,
    fontWeight: themeVariables.fonts.weight.normal,
    lineHeight: themeVariables.fonts.lineHeight["leading-6"],
    letterSpacing: themeVariables.fonts.letterSpacing.normal,
    textDecorationLine: "underline",
    textDecorationStyle: "solid",
    textDecorationSkipInk: "none",
    textDecorationThickness: "auto",
    textUnderlineOffset: "auto",
    textUnderlinePosition: "from-font"
  },
  "heading-xs": {
    color: themeVariables.color.text.tertiary,
    fontFamily: themeVariables.fonts.family.headline,
    fontSize: themeVariables.fonts.size.xs,
    fontWeight: themeVariables.fonts.weight.medium,
    lineHeight: themeVariables.fonts.lineHeight["leading-4"],
    letterSpacing: themeVariables.fonts.letterSpacing.wide
  }
};
const typography = {
  ...themeVariables.typography,
  ...variants,
  // aliases
  "heading-4xl": variants.h1,
  "heading-2xl": variants.h2,
  "heading-xl": variants.h3,
  "heading-lg": variants.h4,
  "heading-md": variants.h5,
  "heading-sm": variants.h6,
  "body-base": variants.body1
};
export {
  typography as default
};
